import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import request from "../../config/Axios";
import List from "../../components/organisms/List";

const MuseumPast = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "상설 전시",
            link: "/program/museum/permanent"
        },
        {
            name: "특별 전시",
            link: "/program/museum/special"
        },
        {
            name: "지난 전시",
            link: "/program/museum/past"
        },
    ];
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);

    useEffect(() => {
        (async () => {
            try {
                const pastResponse = await request.get(`boards/museum/past/posts`);
                setRow(pastResponse.data.data.postList);
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, []);
    // 화면 렌더링
    return (
        <>
            <PageHeader
                bTitle="프로그램"
                detail="지난 전시"
                desc="강아지숲 지난 전시를 안내해 드립니다."
                list={navList}
                top={true}
            />
            <List
                row={row}
                columns={3}
                category={"지난 전시"}
                totalPages={totalPages}
                page={page}
                changePage={setPage}
            />
        </>
    );
};

export default MuseumPast;
